import { request } from 'src/api/request';

export const getReferringOut = async ({ provider_id, queryParams }) => {
  if (!provider_id) return null;
  return request({
    url: `/v1/entities/entity/${provider_id}/affiliations/referring/${queryParams}`,
    method: 'GET',
  });
};
